const messages = {
  Home: "Inicio",
  Check: "Revisar",
  FormAndRegistration: "Formulario y registro",
  InInstaller: "En instalador",
  AssignAnInstaller: "Asignar un instalador",
  Assign: "Asignar",
  Supervisor: "Supervisor",
  RequiredField: "Campo requerido",
  AddTask: "Agregar tarea",
  UpdateTask: "Actualizar tarea",
  PendingTasks: "Tareas pendientes",
  TaskToAuthorize: "Tarea por autorizar",
  TaskDetail: "Detalle tarea",
  Cancel: "Cancelar",
  WasSuccessfullyAdded: "Fue ingresado con éxito",
  WasSuccessfullyAccepted: "Fue aceptado con éxito",
  WasSuccessfullyUpdated: "Fue actualizado con éxito",
  WasSuccessfullyAssigned: "Fue ingresado con éxito",
  WasSuccessfullyDeleted: "Fue eliminado con éxito",
  WasNotAdded: "No fue ingresado",
  WasNotUpdated: "No fue actualizado",
  WasNotAssigned: "No fue asignado",
  WasNotDeleted: "No fue eliminado",
  WasNotAccepted: "No fue aceptada",
  MassageModalTask:
    "Al momento que el instalador descargue la tarea ya no se podrá modificar",
  Description: "Descripción",
  Quantity: "Cantidad",
  Products: "Productos",
  Installer: "Instalador",
  AddInstaller: "Agregar instalador",
  InstallerList: "Listado de instaladores",
  GuideOrInvoice: "Guía o factura",
  CreateTask: "Crear tarea",
  DateStart: "Fecha inicio",
  DateEnd: "Fecha termino",
  New: "Nueva",
  Cancelled: "Cancelado",
  Process: "Proceso",
  InstallationFinished: "Instalación finalizada",
  InstallationPending: "Instalación pendiente",
  InstallationToAuthorize: "Instalación para autorizar",
  MasterListOfCompletedInstallations:
    "Lista maestra de instalaciones realizadas",
  MasterListOfInProcessInstallations:
    "Lista maestra de instalaciones en procesos",
  MasterListOfInstallationsToAuthorize:
    "Lista maestra de instalaciones para autorizar",
  ScheduleNewInstallations: "Agendar nueva instalación",
  Inventory: "Inventario",
  OrderID: "Orden ID",
  Instalation: "Instalación",
  Setting: "Ajustes",
  Messages: "Mensajes",
  Documents: "Documentos",
  Indicators: "Indicadores",
  Clients: "Clientes",
  Client: "Cliente",
  Status: "Estatus",
  Moderator: "Moderador",
  Schedule: "Agenda",
  Product: "Producto",
  Assigned: "Asignado",
  Rejected: "Rechazado",
  Accepted: "Aceptado",
  Executed: "Ejecutada",
  Blocked: "Bloqueado",
  Failed: "Fallida",
  Finished: "Finalizado",
  Created: "Creado",
  Container: "Container",
  DueDate: "Vencimiento",
  ToAuthorize: "Por autorizar",
  Address: "Dirección",
  Action: "Acción",
  ToFinalize: "Finalizadas",
  Pending: "Pendiente",
  Email: "Email",
  RecoverPassword: "Recuperar contraseña",
  SiteDevelopedBy: "Sitio desarrollado por",
  Welcome: "Bienvenido",
  FifoSystem: "Sistema fifo",
  Password: "Contraseña",
  WriteYourEmail: "Escribe tu email",
  WriteYourPass: "Escribe tu contraseña",
  Loading: "Cargando...",
  Name: "Nombre",
  Country: "País",
  Countries: "Paises",
  Yes: "Si",
  No: "No",
  NumberOfStore: "Número de tiendas",
  Contract: "Contrato",
  Edit: "Editar",
  AddAvatar: "Subir imágen",
  Desactive: "Desactivar",
  Active: "Activo",
  Profile: "Perfil",
  Logout: "Cerrar sesión",
  Stores: "Tiendas",
  AddStore: "Agregar tienda",
  ListStores: "Lista de tiendas",
  Companies: "Empresas",
  AddCompany: "Agregar empresa",
  ListCompanies: "Lista de empresas",
  Options: "Opciones",
  Latitude: "Latitud",
  Longitude: "Longitud",
  CanAttendAfterHours: "Puedo atender fuera de horario",
  Selected: "Seleccione",
  Contracts: "Contratos",
  TimeZone: "Zona horaria",
  Ok: "Ok",
  UserEmail: "Email de usuario",
  UserName: "Nombre de usuario",
  TheStoreWasAdded: "La tienda fue agregada",
  TheStoreWasUpdated: "La tienda fue actualizada",
  TheStoreWasDeleted: "La tienda fue eliminada",
  TheStoreWasNotAdded: "La tienda no fue agregada",
  TheStoreWasNotUpdated: "La tienda no fue actualizada",
  TheStoreWasNotDeleted: "La tienda no fue eliminada",
  Add: "Agregar",
  SearchStore: "Buscar tienda",
  Search: "Buscar",
  Search1: "Buscar ...",
  Admin: "Administrador",
  AfterHours: "Fura de horario",
  AddAvatarClient: "Subir imágen a la tienda",
  Avatar1IsOk: "Imágen 1 esta cargada",
  Avatar2IsOk: "Imágen 2 esta cargada",
  Avatar3IsOk: "Imágen 3 esta cargada",
  Avatar1: "Imágen 1",
  Avatar2: "Imágen 2",
  Avatar3: "Imágen 3",
  TheAvatar1WasAdded: "La imágen 1 fue agregada",
  TheAvatar1WasUpdated: "La imágen 1 fue actualizada",
  TheAvatar1WasDeleted: "La imágen 1 fue eliminada",
  TheAvatar1WasNotAdded: "La imágen 1 no fue agregada",
  TheAvatar1WasNotUpdated: "La imágen 1 no fue actualizada",
  TheAvatar1WasNotDeleted: "La imágen 1 no fue eliminada",
  TheAvatar2WasAdded: "La imágen 2 fue agregada",
  TheAvatar2WasUpdated: "La imágen 2 fue actualizada",
  TheAvatar2WasDeleted: "La imágen 2 fue eliminada",
  TheAvatar2WasNotAdded: "La imágen 2 no fue agregada",
  TheAvatar2WasNotUpdated: "La imágen 2 no fue actualizada",
  TheAvatar2WasNotDeleted: "La imágen 2 no fue eliminada",
  TheAvatar3WasAdded: "La imágen 3 fue agregada",
  TheAvatar3WasUpdated: "La imágen 3 fue actualizada",
  TheAvatar3WasDeleted: "La imágen 3 fue eliminada",
  TheAvatar3WasNotAdded: "La imágen 3 no fue agregada",
  TheAvatar3WasNotUpdated: "La imágen 3 no fue actualizada",
  TheAvatar3WasNotDeleted: "La imágen 3 no fue eliminada",
  UpdateStore: "Actualizar tienda",
  Update: "Actualizar",
  TheCompanyWasAdded: "La empresa fue agregada",
  TheCompanyWasUpdated: "La empresa fue actualizada",
  TheCompanyWasDeleted: "La empresa fue eliminada",
  TheCompanyWasNotAdded: "La empresa no fue agregada",
  TheCompanyWasNotUpdated: "La empresa no fue actualizada",
  TheCompanyWasNotDeleted: "La empresa no fue eliminada",
  UpdateCompany: "Actualizar empresa",
  AddAvatarCompany: "Subir imágen a la empresa",
  AreYouSure: "¿Estás seguro?",
  Send: "Enviar",
  PleaseReconnect: "Por favor reingrese",
  KindOfLoad: "Tipo de carga",
  KindOfWeather: "Tipo de clima",
  LoadStatus: "Estado de cargo",
  FileNumber: "Número documento",
  InsulatedProducts: "Productos insulados",
  ComplementaryProducts: "Productos complementarios",
  ContainerNumber: "Container número",
  EmptyContainer: "Container vacío",
  HalfLoadContainer: "Container media carga",
  FullContainer: "Container carga completa",
  ContainerClosedDoor: "Puerta container cerrada",
  Observations: "Observaciones",
  KindOfContainer: "Tipo de container",
  Sign: "Firma",
  Accept: "Aceptar",
  Other: "Otro",
  Revised: "Revisada",
  YouCannotModifyTheTask: "No puedes modificar la tarea",
  YouCannotViewTheTask: "No puedes ver la tarea",
  View: "Ver",
  AddImage: "Agregar Imágenes",
  DeleteImage: "Eliminar Imágen",
  FieldsAreRequerided: "Los campos son requeridos",
  TheImageWasSuccessfullyAdded: "La imagen se agregó con éxito",
  TheImageWasNotAdded: "La imagen no fue agregada",
  TheImageWasSuccessfullyDeleted: "La imagen se eliminocon éxito",
  TheImageWasNotDeleted: "La imagen no fue eliminada",
  Delete: "Eliminar",
  DeleteTask: "Eliminar tarea",
  ForgetMyPassword: "Olvide mi contraseña",
  LogIn: "Iniciar sesión",
  WrongUsernameOrPassword: "Usuario o password incorrecto",
  ThereWasAnError: "Hubo un error",
  NewPasswordWasSendingToYourEmail: "Nuevo password fue enviado a tu email",
  ChangePassSuccessful: "Cambio de contraseña éxitoso",
  ChangeMyPassword: "Cambiar contraseña",
  NewPass: "Nueva contraseña",
  ExpiredSession: "Sesión expirada",
  WriteYourOldPass: "Escribe tu contraseña antigua",
  WriteYourNewPass: "Escribe tu contraseña nueva",
  ChangeLanguageSuccessful: "Cambio de idioma éxitoso",
  ChangeMyLanguageword: "Cambiar mi idioma",
  Languages: "Idiomas",
  Spanish: "Español",
  English: "Ingles",
  WarehouseList: "listado de bodegas",
  Warehouse: "Bodega",
  StreetAndNumber: "Calle y número",
  ProductsList: "Listado de productos",
  Critical: "Crítico",
  Category: "Categoría",
  Codes: "Códigos",
  YouCannotViewTheWareHouse: "No puedes ver la bodega",
  AddProduct: "Agregar producto",
  Code: "Código",
  CodeIsRequired: "Código es requerido",
  Used: "Usado",
  TheProductWasSuccessfullyAdded: "El producto fue agregado con éxito",
  TheProductWasNotAdded: "El producto no fue agregado",
  TheProductWasSuccessfullyMoved: "El producto fue transferido con éxito",
  TheProductWasNotMoved: "El producto no fue transferido",
  Transfer: "Transferir",
  MoveProduct: "Mover producto",
  TheFieldWasSuccessfullyUpdate: "El campo fue éxitosamente actualizado",
  TheFieldOtherWasNotUpdated: "El campo no fue actualizado",
  HomeQA:
    "Descarga la aplicación E-Report en tu dispositivo móvil escaneado el código QR",
  Type: "Tipo",
  NewSitio: "Nueva dirección",
  City: "Ciudad",
  Place: "Lugar",
  PostCode: "Código postal",
  TheAddressWasSuccessfullyAdded: "La dirección fue agregada éxitosamente",
  TheAddressWasNotAdded: "La dirección no fue agregada",
  ClientsList: "Listado de clientes",
  AddClient: "Nuevo cliente",
  Phone: "Teléfono",
  CreateClient: "Crear cliente",
  UpdateClient: "Actualizar cliente",
  Inactive: "Inactivo",
  Activate: "Activar",
  Deactivate: "Desactivar",
  User: "Usuario",
  UpdateInstaller: "Actualizar instalador",
  CreateInstaller: "Crear instalador",
  LastName: "Apellido",
  SupervisorList: "Lista de supervisores",
  AddSupervisor: "Nuevo supervisor",
  SuperAdmin: "Súper administrador",
  CreateSupervisor: "Crear supervisor",
  UpdateSupervisor: "Actualizar supervisor",
  YouCannotCreateSupervisor:
    "No puedes crear supervisores, solo los súper admin",
  RangeControl: "Rangos",
  Lower: "Inferior",
  Upper: "superior",
  ControlList: "Listado de control",
  From: "Desde",
  To: "Hasta",
  StartTime: "Hora Comienzo",
  EndTime: "Hora Termino",
  OutOfTime: "Fuera de tiempo",
  Planner: "Planificador",
  Filter: "Filtro",
  NormalView: "Vista normal",
  SmallView: "Vista reducida",
  InProcess: "En proceso",
  FinishedExecuted: "Finalizada ejecutada",
  FinishedFailed: "Finalizada fallida",
  InstallationInProcess: "Instalación en proceso",
  InstallationCompleted: "Instalación finalizadas",
};

export default messages;
